import { useState } from "react";
import { PasswordField } from "@blog/spa-common";
import { api, ApiError } from "@/lib/api";
import { Button, ErrorNote, Field, Panel, errorMessage, inputClass } from "@/components/ui";

export function ChangePassword({
  forced,
  onDone,
  onCancel,
}: {
  forced: boolean;
  onDone: () => void;
  onCancel?: () => void;
}) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      await api("/api/recruiter/me/password", {
        method: "POST",
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      });
      onDone();
    } catch (e) {
      setError(errorMessage(e instanceof ApiError ? e.code : "unknown"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Panel className="mx-auto max-w-lg">
      <h2 className="mb-1 font-mono text-lg">Cambiar contraseña</h2>
      {forced && (
        <p className="mb-4 text-sm text-mute">
          Tu cuenta la creó el administrador. Antes de usar el portal tienes que elegir una
          contraseña propia.
        </p>
      )}
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <Field label="contraseña actual">
          <input
            className={inputClass}
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
        </Field>
        <Field label="contraseña nueva">
          {/* Comparte la política del blog: ≥12 con mayúscula, minúscula,
              dígito y símbolo, más el chequeo contra filtraciones (HIBP)
              que hace el servidor. */}
          <PasswordField value={next} onChange={setNext} onEnter={() => void submit()} />
        </Field>

        <ErrorNote>{error}</ErrorNote>

        <div className="flex gap-2">
          <Button type="submit" disabled={busy || !current || !next}>
            {busy ? "guardando…" : "cambiar contraseña"}
          </Button>
          {!forced && onCancel && (
            <Button variant="ghost" onClick={onCancel}>
              cancelar
            </Button>
          )}
        </div>
      </form>
    </Panel>
  );
}
